/* eslint-disable indent */
class LoginSuperAdminController {
  /* @ngInject */

  constructor($rootScope, $state, $log, LoginService, $filter, GOOGLE_CLIENT_ID, StorageService) {
    const that = this;
    that.user = {
      name: '',
      password: ''
    };
    that.userTypeError = false;
    that.error = undefined;
    that.loading = false;
    that.googleClientId = GOOGLE_CLIENT_ID;

    var scriptElement = document.createElement('script');
    scriptElement.src = 'https://accounts.google.com/gsi/client';
    scriptElement.onload = function () {
      console.log('Lo script di Google è stato caricato.');
    };
    document.head.appendChild(scriptElement);

    window.onGoogleSignIn = googleUser => {
      const googleJwt = googleUser.credential;
      StorageService.setLocalStorage("access_token", googleJwt);
      StorageService.setLocalStorage('superAdmin', true);
      $rootScope.$broadcast('SUPER_ADMIN_LOGGED_IN');
      that.onLoginCompleted();
      $state.go('listaMerchantSuperAdmin');
    }

    this.login = () => {
      that.userTypeError = false;
      that.error = undefined;
      that.loading = true;
      LoginService.login(this.user.name, this.user.password)
        .then(() => {
          that.onLoginCompleted();
          $state.go('listaMerchantSuperAdmin');
          // location.reload();
        }, (reason) => {

          $log.error('LoginController', 'login', reason);
          let error = reason;
          if (reason.status === 401) {
            that.userTypeError = true;
            error = 'login.errors.credentials';
          } else if (reason === 'login.errors.merchant') {
            that.userTypeError = true;
          }
          that.error = $filter('translate')(error);

        })
        .finally(() => {
          that.loading = false;
        });
    };
  }
}

export default LoginSuperAdminController;



/** WEBPACK FOOTER **
 ** ./client/app/components/loginSuperAdmin/loginSuperAdmin.controller.js
 **/